import { type ReactNode } from 'react'

import ReduxProvider from './redux'
import ThemeProvider from './theme'
import AlgoliaProvider from './algolia'
import HydrationProvider from './hydration'

interface Props {
  element: ReactNode
}

export const wrapWithProviders = ({ element }: Props) => {
  return (
    <HydrationProvider>
      <ReduxProvider>
        <AlgoliaProvider>
          <ThemeProvider>{element}</ThemeProvider>
        </AlgoliaProvider>
      </ReduxProvider>
    </HydrationProvider>
  )
}
